module.exports = __webpack_public_path__ + "static/media/staticEmailNotification.7ead091c.svg";